import { sagas as authentication } from 'ducks/authentication';
import { sagas as automationConditions } from 'ducks/automationConditions';
import { sagas as bootstrap } from 'ducks/bootstrap';
import { sagas as buckets } from 'ducks/buckets';
import { sagas as calibrations } from 'ducks/calibrations';
import { sagas as deploys } from 'ducks/deploys';
import { sagas as deviceLogs } from 'ducks/deviceLogs';
import { sagas as devices } from 'ducks/devices';
import { sagas as deviceVerificationReadings } from 'ducks/deviceVerificationReadings';
import { sagas as deviceVerifications } from 'ducks/deviceVerifications';
import { sagas as equipment } from 'ducks/equipment';
import { sagas as equipmentAttachments } from 'ducks/equipmentAttachments';
import { sagas as equipmentCategories } from 'ducks/equipmentCategories';
import { sagas as indicators } from 'ducks/indicators';
import { sagas as installationPictures } from 'ducks/installationPictures';
import { sagas as installationZones } from 'ducks/installationZones';
import { sagas as loadSite } from 'ducks/loadSite';
import { sagas as logs } from 'ducks/logs';
import { sagas as measurements } from 'ducks/measurements';
import { sagas as protocols } from 'ducks/protocols';
import { sagas as readings } from 'ducks/readings';
import { sagas as sites } from 'ducks/sites';
import { sagas as templates } from 'ducks/templates';
import { sagas as users } from 'ducks/users';
import { sagas as wiseBoxes } from 'ducks/wise_boxes';
import { sagas as wiseBoxDevices } from 'ducks/wiseBoxDevices';
import { all, fork } from 'redux-saga/effects';

export default function* rootSaga() {
    try {
        yield all([
            ...authentication,
            ...automationConditions,
            ...bootstrap,
            ...buckets,
            ...sites,
            ...calibrations,
            ...deploys,
            ...deviceLogs,
            ...deviceVerificationReadings,
            ...deviceVerifications,
            ...devices,
            ...equipment,
            ...equipmentAttachments,
            ...equipmentCategories,
            ...indicators,
            ...installationPictures,
            ...installationZones,
            ...loadSite,
            ...logs,
            ...measurements,
            ...protocols,
            ...readings,
            ...templates,
            ...users,
            ...wiseBoxDevices,
            ...wiseBoxes
        ].map(saga => fork(saga)));
    } catch (error) {
        console.error(error);
    }
}
